<template>
    <div :class="[$style.footer, props.isHidden && $style.hidden]">
        <NonCriticalCSSInject />
        <ShortGameInfo
            :game="props.game"
            :category="props.category"
            placement="desktop_footer"
            :disabledIcon="props.isIconDisabled"
            :limitedAvailability="props.isGameUnavailable"
        />
        <div :class="$style.panel_spacer" />
        <div
            v-if="props.game"
            :class="$style.panel_buttons"
        >
            <HideBarButton
                v-if="props.isFullscreen"
                @click="emit('hidePanel')"
            />
            <InstallButton
                :gamePic="props.game.icon"
                :className="$style.install_button"
            />
            <DiscordButton :className="$style.desktop_plus_only" />
            <LoginButton
                ref="login-button"
                :className="$style.desktop_plus_only"
            />
            <PartnerButton
                v-if="props.game.is_in_export_catalog && props.game.source === 'playgama'"
                :className="$style.desktop_plus_only"
                :hru="props.game.hru"
                :gameIcon="props.game.icon"
            />
            <VoteToggles :game="props.game" />
            <ShareButton
                :shareData="props.shareData"
                :gameIcon="props.game.icon"
            />
            <FullscreenButton
                v-if="!props.isGameUnavailable"
                :isFullscreen="props.isFullscreen"
                @click="emit('toggleFullscreen')"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useTemplateRef } from 'vue'

import NonCriticalCSSInject from '@/components_new/NonCriticalCSSInject.vue'
import type { APIGameType } from '@/types'

import ShortGameInfo from '../../ShortGameInfo.vue'
import FullscreenButton from '../FullscreenButton.vue'
import VoteToggles from '../VoteToggles.vue'
import DiscordButton from './DiscordButton.vue'
import HideBarButton from './HideBarButton.vue'
import InstallButton from './InstallButton.vue'
import LoginButton from './LoginButton.vue'
import PartnerButton from './PartnerButton.vue'
import ShareButton from './ShareButton.vue'

const props = defineProps<{
    game: APIGameType | undefined
    category: string | undefined
    shareData: ShareData
    isIconDisabled?: boolean
    isGameUnavailable?: boolean
    isFullscreen?: boolean
    isHidden?: boolean
}>()

const emit = defineEmits<{
    toggleFullscreen: []
    hidePanel: []
}>()

const loginButton = useTemplateRef('login-button')

defineExpose({
    showLoginTooltip: () => loginButton.value?.showTooltip(),
})
</script>

<style module>
.footer {
    padding: 4px;
    height: 56px;
    box-sizing: border-box;
    display: none;
    gap: 4px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 0 0 var(--container-border-radius) var(--container-border-radius);
}

.panel_spacer {
    flex-grow: 1;
    min-width: 8px;
}

.panel_buttons {
    display: flex;
    gap: 4px;
}

.footer.hidden {
    display: none;
}

.desktop_plus_only {
    display: none;
}

/* Hide install button on Firefox as it doesn't support PWA installation */
@supports (-moz-appearance: none) {
    .install_button {
        display: none;
    }
}

@media (--tablet-plus) {
    .footer {
        display: flex;
    }
}

@media (--desktop-small-plus) {
    .desktop_plus_only {
        display: block;
    }
}
</style>
